import { render } from "./PrivacySettingSection.vue?vue&type=template&id=cf484196"
import script from "./PrivacySettingSection.vue?vue&type=script&lang=js"
export * from "./PrivacySettingSection.vue?vue&type=script&lang=js"
script.render = render

export default script